function getCardFlag(cardNumber) {
  const cards = {
    visa: cardNumber >= 40 && cardNumber < 50,
    master: cardNumber >= 51 && cardNumber <= 55,
    amex: cardNumber >= 34 && cardNumber <= 37,
    elo: cardNumber >= 50 && cardNumber <= 69
  };

  for (var flag in cards) {
    if (cards[flag]) {
      return flag;
    }
  }

  return false;
}

export default getCardFlag;
